// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";
import * as ArticleItem$BenfaerberBlog from "../components/ArticleItem.bs.js";

function s(prim) {
  return prim;
}

function BlogPage(props) {
  var match = React.useState(function () {
        return {
                articles: [],
                isLoading: true
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          Blog$BenfaerberBlog.Api.getArticles().then(function (articles) {
                return Promise.resolve(setState(function (param) {
                                return {
                                        articles: articles,
                                        isLoading: false
                                      };
                              }));
              });
        }), []);
  return JsxRuntime.jsx("div", {
              children: state.isLoading ? Belt_Array.map(Belt_Array.range(0, 10), (function (i) {
                        return JsxRuntime.jsx("div", {
                                    className: "article-is-loading"
                                  }, String(i));
                      })) : Belt_Array.mapWithIndex(state.articles, (function (i, a) {
                        return JsxRuntime.jsx(ArticleItem$BenfaerberBlog.make, {
                                    article: a
                                  }, String(i));
                      }))
            });
}

var make = BlogPage;

export {
  s ,
  make ,
}
/* react Not a pure module */
